"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _utils = _interopRequireDefault(require("../../../utils/utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LabelElement = function LabelElement(_ref) {
  var item = _ref.item;
  console.log("ESTILOS label field: ", item.attributes);
  var defaultStyles = {
    display: "flex",
    alignItems: item.attributes.alignItems,
    fontWeight: item.attributes.bold ? 500 : 300,
    color: item.attributes.color || "#000000de",
    fontSize: item.attributes.fontSize,
    fontFamily: item.attributes.fontFamily
  };
  var style = !item.isActiveCustomStyles ? defaultStyles : _utils.default.stringToObject(item.customStyles);
  console.log("ESTILOS label style: ", style);
  return /*#__PURE__*/React.createElement(_core.Typography
  /*className="revert-font"*/
  , {
    variant: item.attributes.variant,
    fontSize: item.attributes.fontSize,
    style: style
  }, "".concat(item.attributes.label).concat(item.attributes.hasTitle ? ": {{name}}" : ""));
};

var _default = LabelElement;
exports.default = _default;